/*

THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE BILLING ADDRESS FORM

*/

import React, { useEffect } from 'react';
import './BillingAddress.css';
import { updateBillingAddress, setPaymentStatus } from '../../../actions/actionCreators';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import CustomTextField from '../ShippingAddress/CustomTextField';
import CartService from '../../../services/CartService';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { useTranslation } from 'react-i18next';
import AutoCompleteField from '../ShippingAddress/AutoCompleteField';

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiTypography-body1": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontSize: "1.1rem",
    },
  },
  expanded: {},
  content: {
    margin: 0,
    '&$expanded': {
      margin: '10px 0',
    },
  },
}));

const BillingAddress = () => {
  const classes = useStyles();
  const cart = useSelector(state => state.cartReducer, shallowEqual)
  const geocoder = new window.google.maps.Geocoder();
  const dispatch = useDispatch();
  const [value, setValue] = React.useState('same_as_shipping');
  const [rIndex, setRIndex] = React.useState(1);
  const { t } = useTranslation();
  
  useEffect(() => {
    validateBillingAddress()
  }, [])

  const validateBillingAddress = () => {
    if (!cart.billing_address) {
      dispatch(updateBillingAddress(initWithShippingAddress()));
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
    if (event.target.value === 'same_as_shipping') {
      let newIndex = rIndex+1;
      setRIndex(newIndex);
      dispatch(setPaymentStatus([{fieldToUpdate: 'billingAsShipping', value: true}]));
      dispatch(updateBillingAddress(initWithShippingAddress()));
    } else {
      let newIndex = rIndex+1;
      setRIndex(newIndex);
      dispatch(setPaymentStatus([{fieldToUpdate: 'billingAsShipping', value: false}]));
      // dispatch(updateBillingAddress(initWithEmpty()));
      dispatch(updateBillingAddress(initWithShippingAddress()));
    }
  };


  return (
    <div className="BillingAddressContainer">
      <RadioGroup aria-label="billing_address" name="billing_address" value={value} onChange={handleChange}>
        <Accordion expanded={value === 'same_as_shipping'} style={{boxShadow: 'none', margin: 0}}>
          <AccordionSummary
            aria-controls="additional-actions1-content"
            id="additional-actions1-header"
            classes={{ content: classes.content, expanded: classes.expanded }}   
            style={{minHeight: 25}}       
            >
            <FormControlLabel
              className={classes.root}
              control={<Radio color="primary" />}
              label={t("Same as shipping address")}
              value="same_as_shipping"
            />
          </AccordionSummary>
        </Accordion>
        <Accordion expanded={value === 'new_address'} style={{boxShadow: 'none'}}>
          <AccordionSummary
            aria-controls="additional-actions2-content"
            id="additional-actions2-header"
            classes={{ content: classes.content, expanded: classes.expanded }}
          >
            <FormControlLabel
              className={classes.root}
              control={<Radio color="primary" />}
              label={t("Use a different billing address")}
              value="new_address"
            />
          </AccordionSummary>
          <AccordionDetails style={{ padding: '0px' }}>
            {
              cart.billing_address !== null ?
              <div key={rIndex}>
                { renderCustomerName() }
                { renderPhoneCompany() }
                { renderAddress1() }
                { renderAddress2() }
                { renderCityProvinceCountry() }
              </div> : null
            }
          </AccordionDetails>
        </Accordion>
      </RadioGroup>
    </div>
  );

  function renderCustomerName() {
    return (
      <div className="CustomerNameContainer">
        <CustomTextField
          fieldId={"first-name"}
          label="First Name"
          defaultValue={cart.billing_address.first_name}
          onEditCallBack={editFirstName}
          helperText="Field is required"
        />
        <CustomTextField
          fieldId={"last-name"}
          label="Last Name"
          defaultValue={cart.billing_address.last_name}
          onEditCallBack={editLastName}
          helperText="Field is required"
        />
      </div>
    )
  }

  function renderPhoneCompany() {
    return (
      <div className="PhoneCompanyContainer">
        <CustomTextField
          fieldId={"company-name"}
          label="Company"
          defaultValue={cart.billing_address.company}
          onEditCallBack={editCompany}
          optional={true}
          containerStyle={{ width: '45%' }}
        />
        <CustomTextField
          fieldId={"phone"}
          label="Phone Number"
          defaultValue={cart.billing_address.phone}
          onEditCallBack={editPhone}
          helperText="Field is required"
          helperTextSecondary="Enter a valid phone number 438 795 2709"
        />
      </div>      
    )
  }

  function renderAddress1() {
    return (
      <div className="AddressContainer">
        <CustomTextField
          fieldId={"address"}
          label="Address"
          defaultValue={cart.billing_address.address1}
          onEditCallBack={editAddressNoValidation}
          containerStyle={{ width: '100%' }}
          helperText="Field is required"
          helperTextSecondary="Enter a valid address"
        />
        {/* <AutoCompleteField
          fieldId={"address"}
          label="Address"
          defaultValue={cart.billing_address.address1}
          onEditCallBack={editAddress}
          helperText="Field is required"
          width={{ width: '100%' }}
        /> */}

      </div>
    )
  }

  function renderAddress2() {
    return (
      <div className="AddressAptContainer">
        <CustomTextField
          fieldId={"apartment"}
          label="Apt, suite, etc. (optional)"
          defaultValue={cart.billing_address.address2}
          onEditCallBack={editApartment}
          optional={true}
          containerStyle={{ width: '45%' }}
        />
        <CustomTextField
          fieldId={"zip"}
          country={cart.billing_address.country}
          label="Postal Code"
          defaultValue={cart.billing_address.zip}
          onEditCallBack={editZip}
          helperText="Field is required"
          helperTextSecondary="Enter a valid postal code"
        />
      </div>
    )
  }

  function renderCityProvinceCountry() {
    return (
      <div className="CityContainer">
        <CustomTextField
          fieldId={"city"}
          label="City"
          defaultValue={cart.billing_address.city}
          onEditCallBack={editCity}
          helperText="Field is required"
          disabled={false}
          containerStyle={{ width: '25%' }}
        />
        <CustomTextField
          fieldId={"province"}
          label="Province"
          defaultValue={cart.billing_address.province}
          onEditCallBack={editProvince}
          helperText="Field is required"
          disabled={false}
          containerStyle={{ width: '25%' }}
        />
        <CustomTextField
          fieldId={"country"}
          label="Country"
          defaultValue={cart.billing_address.country}
          onEditCallBack={editCountry}
          helperText="Field is required"
          disabled={false}
          containerStyle={{ width: '25%' }}
        />
      </div>
    )
  }

  function editFirstName(value) {
    let payload = [{ fieldToUpdate: 'first_name', value: value }];
    dispatch(updateBillingAddress(payload));
  }

  function editLastName(value) {
    let payload = [{ fieldToUpdate: 'last_name', value: value }];
    dispatch(updateBillingAddress(payload));
  }

  function editPhone(value) {
    let payload = [{ fieldToUpdate: 'phone', value: value }];
    dispatch(updateBillingAddress(payload));
  }

  function editCompany(value) {
    let payload = [{ fieldToUpdate: 'company', value: value }];
    dispatch(updateBillingAddress(payload));
  }

  function editAddress(value) {
    // let payload = getCompiledCustomerInfo();
    if (Array.isArray(value.terms)) {
      const lastIndex = value.terms.length - 1;

    let payload = [
      { fieldToUpdate: 'address1', value: value.terms[0].value + ' ' + value.terms[1].value },
      { fieldToUpdate: 'city', value: value.terms[lastIndex - 2].value },
      { fieldToUpdate: 'country', value: value.terms[lastIndex].value },
      { fieldToUpdate: 'province_code', value: value.terms[lastIndex - 1].value }

    ]

    geocoder.geocode({ 'placeId': value.place_id }, async (results, status) => {
      const addCompIndex = results[0].address_components.length - 1;
      for (var i = addCompIndex; i >= 0; i--) {
        let component = results[0].address_components[i];

        if (component.types.includes('postal_code')) {
          payload.push({ fieldToUpdate: 'zip', value: component.short_name })
          // break;
        } else if (component.types.includes('administrative_area_level_1')) {
          payload.push({ fieldToUpdate: 'province', value: component.long_name })
        } else if (component.types.includes('country')) {
          payload.push({ fieldToUpdate: 'country_code', value: component.short_name })
        }

        if (payload.length === 7) {
          dispatch(updateBillingAddress(payload));
          break;
        }
      }
    })
    }
  }

  function editAddressNoValidation(value) {
    let payload = [{ fieldToUpdate: 'address1', value: value }];
    dispatch(updateBillingAddress(payload));
  }

  function editApartment(value) {
    let payload = [{ fieldToUpdate: 'address2', value: value }];
    dispatch(updateBillingAddress(payload));
  }

  function editCity(value) {
    let payload = [{ fieldToUpdate: 'city', value: value }];
    dispatch(updateBillingAddress(payload));
  }

  function editCountry(value) {
    let payload = [{ fieldToUpdate: 'country', value: value }];
    dispatch(updateBillingAddress(payload));
  }

  function editProvince(value) {
    let payload = [{ fieldToUpdate: 'province', value: value }];
    dispatch(updateBillingAddress(payload));
  }

  function editZip(value) {
    let payload = [{ fieldToUpdate: 'zip', value: value }];
    dispatch(updateBillingAddress(payload));
  }

  async function postUpdatedAddress() {
    let response = await CartService.updateBillingAddress(cart.billing_address, cart.token);
    if (response.error == null) {
      // to do: add error handling
    } 
  }

  function initWithShippingAddress() {
    return [
      { fieldToUpdate: 'first_name', value: cart.shipping_address.first_name },
      { fieldToUpdate: 'last_name', value: cart.shipping_address.last_name },
      { fieldToUpdate: 'phone', value: cart.shipping_address.phone },
      { fieldToUpdate: 'address1', value: cart.shipping_address.address1 },
      { fieldToUpdate: 'address2', value: cart.shipping_address.address2 },
      { fieldToUpdate: 'city', value: cart.shipping_address.city },
      { fieldToUpdate: 'country', value: cart.shipping_address.country },
      { fieldToUpdate: 'country_code', value: cart.shipping_address.country_code },
      { fieldToUpdate: 'province_code', value: cart.shipping_address.province_code },
      { fieldToUpdate: 'zip', value: cart.shipping_address.zip }
    ];
  }

  function initWithEmpty() {
    return [
      { fieldToUpdate: 'first_name', value: '' },
      { fieldToUpdate: 'last_name', value: '' },
      { fieldToUpdate: 'phone', value: '' },
      { fieldToUpdate: 'address1', value: '' },
      { fieldToUpdate: 'address2', value: '' },
      { fieldToUpdate: 'city', value: '' },
      { fieldToUpdate: 'country', value: '' },
      { fieldToUpdate: 'province_code', value: '' },
      { fieldToUpdate: 'zip', value: '' }
    ];
  }
}

export default BillingAddress;
